var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 35.13V68.26H34.87C53.17 68.26 68 53.43 68 35.13C68 16.83 53.17 2 34.87 2C16.57 2 2 16.83 2 35.13Z",
    stroke: "#D1D5DB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4995 40.9297C28.898 40.9297 27.5996 39.6313 27.5996 38.0298C27.5996 36.4282 28.898 35.1299 30.4995 35.1299C32.1011 35.1299 33.3994 36.4282 33.3994 38.0298C33.3994 39.6313 32.1011 40.9297 30.4995 40.9297Z",
    fill: "#D1D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8999 40.9297C17.2983 40.9297 16 39.6313 16 38.0298C16 36.4282 17.2983 35.1299 18.8999 35.1299C20.5015 35.1299 21.7998 36.4282 21.7998 38.0298C21.7998 39.6313 20.5015 40.9297 18.8999 40.9297Z",
    fill: "#D1D5DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54 29L41 42",
    stroke: "#D1D5DB",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 29L54 42",
    stroke: "#D1D5DB",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_error.343c8791ae42ca84419922f307a0fdc8.svg";
export { ForwardRef as ReactComponent };